<div id="empresas" class="page-layout simple left-sidebar inner-sidebar inner-scroll">

    <!-- HEADER -->
    <div class="header accent p-16 p-sm-24" fxLayout="column" fxLayoutAlign="start"
         fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

        <!-- APP TITLE -->
        <div fxLayout="row" fxLayoutAlign="start center">            

            <div class="logo" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon mr-16"
                          [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">account_box
                </mat-icon>
                <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
                    Empresas
                </span>
            </div>

        </div>
        <!-- / APP TITLE -->

        <!-- SEARCH -->
        <div class="ml-sm-32" fxLayout="row" fxLayoutAlign="center center" fxFlex>

            <div class="search-wrapper mt-16 mt-sm-0">

                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <!-- <mat-form-field> -->
                    <input (keyup)="doFilter($event.target.value)" placeholder="Buscar empresa">
                    <!-- </mat-form-field> -->
                    
                </div>

            </div>

            <div class="ml-sm-32" fxLayoutAlign="end right" style="margin-left: 3em;">
                <button mat-mini-fab [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu>
                <!-- <button mat-menu-item>
                    <mat-icon>add_circle</mat-icon>
                    <span>Añadir empresa</span>
                </button> -->
                <button mat-menu-item (click)="logOut()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Cerrar sesión</span>
                </button>
                </mat-menu>
            </div>
        </div>
        <!-- / SEARCH -->     
       
        <!-- <button mat-icon-button style="float: right; padding: 10px; margin-right: 10px">
            <mat-icon>add_circle</mat-icon>
        </button>
        <button mat-icon-button style="float: right; padding: 10px; margin-right: 10px" (click)="logOut()">
            <mat-icon>exit_to_app</mat-icon>
        </button> -->
        
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content">

        <!-- CENTER -->
        <div class="center p-24 pb-56 pr-sm-92" style="margin-left: 10%; margin-right: 10%;" fusePerfectScrollbar>

            <!-- CONTENT -->
            <div class="content" style="width: auto;">
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width: 100%;">
              
                    <ng-container matColumnDef="empresas">
                      <th mat-header-cell *matHeaderCellDef> Empresa</th>
                      <td mat-cell *matCellDef="let element"> {{element.nombreComercial}} </td>
                    </ng-container>
                  
                    <ng-container matColumnDef="nit">
                      <th mat-header-cell *matHeaderCellDef  fxHide fxShow.gt-xs> NIT </th>
                      <td mat-cell *matCellDef="let element"  fxHide fxShow.gt-xs> {{element.nit}} </td>
                    </ng-container>
                  
                    <ng-container matColumnDef="acciones">
                      <th mat-header-cell *matHeaderCellDef> Acciones </th>
                      <td mat-cell *matCellDef="let element">
                        <button mat-icon-button (click)="getIdEmpresas(element.id)">
                            <mat-icon>arrow_forward</mat-icon>
                        </button>
                      </td>
                    </ng-container>                          
                  
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CENTER -->

    </div>
    <!-- / CONTENT-->
    
</div>